import axios from 'axios';
import { saveUserAction } from './saveUserAction';

axios.defaults.withCredentials = true;

export async function logout(email) {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}logout`);
    Auth.postMessage('logout')
    
    saveUserAction({ email, id_accion: 5, detalles_accion: `Logout` });

    return response

  } catch (error) {
    saveUserAction({ email, id_accion: 5, detalles_accion: `Error al hacer logout` });

    console.error('Error de logout', error);
  }
}